import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { noop } from '../../../utils/noop';
import { BackgroundOverlayStyles } from './BackgroundOverlay.style';

const BackgroundOverlay = ({ shade }) => {
  const overlayRef = useRef();
  if (typeof window === 'object') {
    return createPortal(
      <div
        ref={overlayRef}
        onKeyDown={noop}
        tabIndex="0"
        role="button"
        className={cx(`background-overlay`, typeof shade === 'string' && `shade-${shade}`)}
      >
        <style jsx>{BackgroundOverlayStyles}</style>
      </div>,
      document.body
    );
  }
  return null;
};

BackgroundOverlay.defaultProps = {
  shade: null,
};

BackgroundOverlay.propTypes = {
  shade: PropTypes.oneOf(['lighter']),
};

export { BackgroundOverlay };
